/** Traductions modal ajout commande (FR / AR) */
export const addOrderModalFr = {
  fillProductFields: 'Veuillez remplir tous les champs du produit',
  selectSupplier: 'Veuillez sélectionner un fournisseur',
  addAtLeastOneProduct: 'Veuillez ajouter au moins un produit à la commande',
  title: 'Ajouter Nouvelle Commande',
  orderDetails: 'Détails de la Commande',
  supplier: 'Fournisseur',
  selectSupplierPlaceholder: 'Sélectionner Fournisseur',
  newShort: '+ Nouveau',
  expectedDelivery: 'Date de Livraison Prévue',
  datePlaceholder: 'JJ/MM/AAAA',
  stockLocation: 'Emplacement du Stock',
  mainStock: 'Stock Principal',
  addProductsSection: 'Ajouter Produits',
  searchProduct: 'Rechercher Produit *',
  searchPlaceholder: 'Rechercher un produit...',
  searchMinChars: 'Tapez 3 lettres pour filtrer',
  na: 'N/D',
  liveChickens: 'Poulets Vivants',
  slaughteredChickens: 'Poulets Abattus',
  deadChickens: 'Poulets Morts',
  stockLabel: 'Stock',
  unitsPerPackageExample: 'ex : 24',
  unitsPerPackage: 'Unités par emballage *',
  packagesExample: 'ex : 5',
  packagesCount: 'Number of Packages *',
  expiryDate: "Date d'Expiration",
  expiryDatePast: "Impossible d'ajouter un produit avec une date d'expiration déjà passée",
  pricePerCarton: 'Prix par carton',
  autoCalculated: 'Calculé automatiquement',
  sellingPricePerUnit: 'Prix de vente par unité',
  total: 'Total',
  orderPrice: 'Order Price *',
  sellingPrice: 'Selling Price',
  quantity: 'Quantité *',
  orderPriceFr: 'Prix de Commande *',
  sellingPriceFr: 'Prix de Vente',
  addProductToOrder: 'Ajouter Produit à la Commande',
  productsInOrder: 'Produits dans la Commande',
  colProduct: 'Produit',
  colQty: 'Qté',
  colOrderPrice: 'Prix de Commande',
  colSellingPrice: 'Prix de Vente',
  colTotal: 'Total',
  colAction: 'Action',
  remove: 'Supprimer',
  cancel: 'Annuler',
  createOrder: 'Créer Commande'
};

export const addOrderModalAr = {
  fillProductFields: 'يرجى ملء جميع الحقول المطلوبة للمنتج',
  selectSupplier: 'يرجى اختيار مورد للطلب',
  addAtLeastOneProduct: 'يرجى إضافة منتج واحد على الأقل إلى الطلب',
  title: 'إضافة طلب جديد',
  orderDetails: 'تفاصيل الطلب',
  supplier: 'المورد',
  selectSupplierPlaceholder: 'اختر المورد *',
  newShort: '+ جديد',
  expectedDelivery: 'تاريخ التسليم المتوقع',
  datePlaceholder: 'يوم/شهر/سنة',
  stockLocation: 'موقع المخزون',
  mainStock: 'المخزون الرئيسي',
  addProductsSection: 'إضافة المنتجات',
  searchProduct: 'البحث عن المنتج *',
  searchPlaceholder: 'ابحث عن منتج بالاسم أو الرمز...',
  searchMinChars: 'اكتب 3 أحرف على الأقل للبحث',
  na: 'بدون',
  liveChickens: 'دجاج حي',
  slaughteredChickens: 'دجاج مذبوح',
  deadChickens: 'دجاج ميت',
  stockLabel: 'المخزون',
  unitsPerPackageExample: 'مثال: 24',
  unitsPerPackage: 'عدد الوحدات في العبوة *',
  packagesExample: 'مثال: 5',
  packagesCount: 'عدد العبوات *',
  expiryDate: 'تاريخ انتهاء الصلاحية',
  expiryDatePast: 'لا يمكن إضافة منتج بتاريخ انتهاء صلاحية قد مضى',
  pricePerCarton: 'سعر الكرتونة الواحدة',
  autoCalculated: 'محسوب تلقائياً',
  sellingPricePerUnit: 'سعر البيع لكل وحدة',
  total: 'الإجمالي',
  orderPrice: 'سعر الطلب *',
  sellingPrice: 'سعر البيع',
  quantity: 'الكمية *',
  orderPriceFr: 'سعر الطلب *',
  sellingPriceFr: 'سعر البيع',
  addProductToOrder: 'إضافة المنتج للطلب',
  productsInOrder: 'المنتجات في الطلب',
  colProduct: 'المنتج',
  colQty: 'الكمية',
  colOrderPrice: 'سعر الطلب',
  colSellingPrice: 'سعر البيع',
  colTotal: 'الإجمالي',
  colAction: 'الإجراء',
  remove: 'حذف',
  cancel: 'إلغاء',
  createOrder: 'إنشاء الطلب'
};

/** Traduit les noms de produits volaille codés en dur */
export function translatePoultryProductName(name, t) {
  if (name === 'Live Chickens') return t('addOrderModal.liveChickens');
  if (name === 'Slaughtered Chickens') return t('addOrderModal.slaughteredChickens');
  if (name === 'Dead Chickens') return t('addOrderModal.deadChickens');
  return name;
}
